import type Stripe from 'stripe';
import axios from './api';
import API_URL from '../apiconfig';
import { BaseCapitalPayload } from '../types/capital';

export const getCapitalAccountSession = async (payload: BaseCapitalPayload) => {
  const response = await axios.get(`${API_URL}/v1/capital/session`, {
    params: payload,
  });

  return response?.data?.result as Stripe.AccountSession;
};
